import { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import {
    Card, Stack, Container, Typography, Alert, CircularProgress, Link, Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Page from 'src/components/Page';
import syndicationApi from 'src/utils/syndicationApi';

const RootStyle = styled(Page)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    padding: theme.spacing(4, 0),
}));

const FormCard = styled(Card)(({ theme }) => ({
    maxWidth: 500,
    width: '100%',
    padding: theme.spacing(5),
    borderRadius: 16,
    boxShadow: '0 8px 40px rgba(0,0,0,0.12)',
}));

export default function InvestorVerifyEmail() {
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [newStatus, setNewStatus] = useState('');

    useEffect(() => {
        if (token) {
            syndicationApi.post('investor/verify-email/', { token })
                .then((response) => {
                    setSuccess(true);
                    setMessage(response.data?.message || 'Email verified successfully.');
                    setNewStatus(response.data?.data?.new_status || '');
                })
                .catch((error) => {
                    setSuccess(false);
                    setMessage(error.response?.data?.message || 'Verification failed. The link may be expired or invalid.');
                })
                .finally(() => setLoading(false));
        }
    }, [token]);

    return (
        <RootStyle title="Verify Email | Gateway X Syndication">
            <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center' }}>
                <FormCard>
                    <Stack spacing={3} alignItems="center" sx={{ textAlign: 'center' }}>
                        <Typography variant="h4">Email Verification</Typography>

                        {loading && (
                            <Box sx={{ py: 4 }}>
                                <CircularProgress />
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                                    Verifying your email...
                                </Typography>
                            </Box>
                        )}

                        {!loading && success && (
                            <>
                                <Alert severity="success" sx={{ width: '100%' }}>{message}</Alert>
                                {newStatus === 'pending_approval' && (
                                    <Typography variant="body2" color="text.secondary">
                                        Your account is now pending admin review. You'll receive an email once approved.
                                    </Typography>
                                )}
                                {newStatus === 'approved' && (
                                    <Typography variant="body2" color="text.secondary">
                                        Please check your email for the 2FA setup link to complete your account activation.
                                    </Typography>
                                )}
                            </>
                        )}

                        {!loading && !success && (
                            <Alert severity="error" sx={{ width: '100%' }}>{message}</Alert>
                        )}

                        <Link component={RouterLink} to="/investor/login" variant="subtitle2">
                            Go to Login
                        </Link>
                    </Stack>
                </FormCard>
            </Container>
        </RootStyle>
    );
}
